<template>
    <div class="login">
        <!-- 登录 -->
        <el-dialog
          v-if="show=='login'"
          :visible.sync="loginVisible"
          :before-close="handleClose"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          custom-class="premium-dialog"
          width="400px"
          center>
          <div class="dialog-content">
              <h2 class="dialog-title">Account Login</h2>
              <p class="dialog-subtitle">Welcome back, please log in to your account</p>
              
              <div class="form-group mar-top-30">
                    <label class="form-label">Phone Number</label>
                    <div class="input-wrapper">
                        <i class="el-icon-phone input-icon"></i>
                        <input v-model="phoneNumber" type="number" placeholder="Enter phone number">
                    </div>
              </div>
              
              <div v-if="activeName=='pwdLogin'" class="form-group mar-top-20">
                  <label class="form-label">Password</label>
                  <div class="input-wrapper">
                      <i class="el-icon-lock input-icon"></i>
                      <input v-model="pwd" type="password" placeholder="Enter password">
                  </div>
              </div>

              <div class="flex-between mar-top-15">
                  <span class="link-text" @click="toRegister">Register Now</span>
                  <span v-if="activeName=='pwdLogin'" class="link-text" @click="toForgot">Forgot Password?</span>
              </div>

              <div class="btn-group mar-top-30">
                  <el-button :loading="loading" type="primary" class="w100 premium-btn" @click="login">L O G I N</el-button>
              </div>
          </div>
        </el-dialog>

        <!-- 注册 -->
        <el-dialog
          v-if="show=='register'"
          :visible.sync="loginVisible"
          :before-close="handleClose"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          custom-class="premium-dialog"
          width="400px"
          center>
          <div class="dialog-content">
              <h2 class="dialog-title">Register Account</h2>
              <p class="dialog-subtitle">Start your GRAVITY SHOP journey</p>

              <div class="form-group mar-top-30">
                  <label class="form-label">Phone Number</label>
                  <div class="input-wrapper">
                      <i class="el-icon-phone input-icon"></i>
                      <input v-model="phoneNumber1" type="number" placeholder="Enter phone number">
                  </div>
              </div>

              <div class="form-group mar-top-20">
                  <label class="form-label">Password</label>
                  <div class="input-wrapper">
                      <i class="el-icon-lock input-icon"></i>
                      <input v-model="pwd1" type="password" placeholder="Set login password">
                  </div>
              </div>

              <div class="form-group mar-top-20">
                  <label class="form-label">Confirm Password</label>
                  <div class="input-wrapper">
                      <i class="el-icon-circle-check input-icon"></i>
                      <input v-model="pwdAgain" type="password" placeholder="Enter password again">
                  </div>
              </div>

              <div class="clause-wrapper mar-top-20">
                  <div class="checkbox-custom" :class="{active: read}" @click="select">
                      <i v-if="read" class="el-icon-check"></i>
                  </div>
                  <span class="clause-text">I have read and agree to the <span class="link-text">Privacy Terms</span></span>
              </div>

              <div class="btn-group mar-top-30">
                  <el-button :loading="loading1" type="primary" class="w100 premium-btn" @click="register">Register Now</el-button>
                  <p class="mar-top-15 text-center fs14 gray-500">
                      Already have an account? <span class="link-text" @click="toLogin">Log In</span>
                  </p>
              </div>
          </div>
        </el-dialog>

        <!-- 忘记密码 -->
        <el-dialog
          v-if="show=='forgot'"
          :visible.sync="loginVisible"
          :before-close="handleClose"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          custom-class="premium-dialog"
          width="400px"
          center>
          <div class="dialog-content">
              <h2 class="dialog-title">Reset Password</h2>
              <p class="dialog-subtitle">Reset your account password</p>

              <div class="form-group mar-top-30">
                  <label class="form-label">Phone Number</label>
                  <div class="input-wrapper">
                      <i class="el-icon-phone input-icon"></i>
                      <input v-model="phoneNumber2" type="number" placeholder="Enter phone number">
                  </div>
              </div>

              <div class="form-group mar-top-20">
                  <label class="form-label">New Password</label>
                  <div class="input-wrapper">
                      <i class="el-icon-lock input-icon"></i>
                      <input v-model="pwd2" type="password" placeholder="Set new password">
                  </div>
              </div>

              <div class="btn-group mar-top-30">
                  <el-button :loading="loading2" type="primary" class="w100 premium-btn" @click="getBack">Confirm Reset</el-button>
                  <p class="mar-top-15 text-center fs14 gray-500">
                      Remembered your password? <span class="link-text" @click="toLogin">Log In</span>
                  </p>
              </div>
          </div>
        </el-dialog>
    </div>
</template>

<script>
// ... (keep the existing script logic unchanged)
import Cookie from 'js-cookie'
import {mapGetters, mapMutations} from 'vuex'
import {cartCount} from '@/api/cart.js'
import {
    getVerify,
    loginWeb,
    registerID,
    getUserInfo
} from '@/api/login.js'
export default {
    name: 'login',
    data () {
        return {
            show: 'login',
            activeName: 'pwdLogin',
            registerVisible: true,
            forgotVisible: true,
            loading: false,
            loading1: false,
            loading2: false,
            phoneNumber: null,
            phoneNumber1: null,
            phoneNumber2: null,
            authCode: null,
            authCode1: null,
            authCode2: null,
            pwd: '',
            pwd1: '',
            pwd2: '',
            pwdAgain: '',
            pwdAgain1: '',
            showTime: false,
            showTime1: false,
            showTime2: false,
            time: 60,
            time1: 60,
            time2: 60,
            timer: null,
            timer1: null,
            timer2: null,
            read: false,
            relus: /^1[13456789]\d{9}$/
        }
    },
    computed: {
        ...mapGetters([
          'loginVisible' // 登录注册弹窗开关
        ])
    },
    methods: {
        ...mapMutations({
          setUserInfo: 'SET_USERINFO', // 修改用户信息
          setCartNum: 'SET_CARTNUM' // 修改购物车商品数量
        }),
        countDown () {
            this.showTime = true
            clearInterval(this.timer)
            this.timer = setInterval(() => {
                if (this.time > 0) {
                    this.time--
                } else {
                    this.showTime = false
                    clearInterval(this.timer)
                    this.time = 60
                }
            }, 1000)
        },
        countDown1 () {
            this.showTime1 = true
            clearInterval(this.timer1)
            this.timer1 = setInterval(() => {
                if (this.time1 > 0) {
                    this.time1--
                } else {
                    this.showTime1 = false
                    clearInterval(this.timer1)
                    this.time1 = 60
                }
            }, 1000)
        },
        countDown2 () {
            this.showTime2 = true
            clearInterval(this.timer2)
            this.timer2 = setInterval(() => {
                if (this.time2 > 0) {
                    this.time2--
                } else {
                    this.showTime2 = false
                    clearInterval(this.timer2)
                    this.time2 = 60
                }
            }, 1000)
        },
        codeLogin () {
            this.$message.warning('SMS login is not yet available')
        },
        passwordLogin () { this.activeName = 'pwdLogin' },
        getCode () {
            if (this.phoneNumber === null) {
                return this.$message.warning('Please enter phone number')
            } else if (!this.relus.test(this.phoneNumber)) {
                return this.$message.warning('Invalid phone number format')
            }
            getVerify({
                phone: this.phoneNumber,
                type: 'login'
            }).then(res => {
                 if (res.status === 200) {
                    this.$message.success(this.$t('common.verifyCodeSuccess'))
                    this.countDown()
                } else {
                    this.$message.warning(res.msg)
                }
            })
        },
        getCode1 () {
            if (this.phoneNumber1 === null) {
                return this.$message.warning('Please enter phone number')
            } else if (!this.relus.test(this.phoneNumber1)) {
                return this.$message.warning('Invalid phone number format')
            }
            getVerify({
                phone: this.phoneNumber1,
                type: 'register'
            }).then(res => {
                if (res.status === 200) {
                    this.$message.success(this.$t('common.verifyCodeSuccess'))
                    this.countDown1()
                } else {
                    this.$message.warning(res.msg)
                }
            })
        },
        toRegister () { this.show = 'register' },
        toForgot () { this.show = 'forgot' },
        toLogin () { this.show = 'login' },
        login () {
            if (this.pwd.length < 4 || this.pwd.length > 16) {
                return this.$message.warning('Please enter a 4-16 character password')
            }
            this.loading = true
            loginWeb({
                username: this.phoneNumber,
                password: this.pwd
            }).then(res => {
                if (res.status === 200) {
                    Cookie.set('Gravity_token', res.data.token)
                    this.$message.success('Login successful')
                    this.getUserInfo()
                    this.getCartNum()
                    this.handleClose()
                    location.reload()
                } else {
                    this.$message.warning(res.msg)
                }
            })
            this.loading = false
        },
        async getCartNum () {
            var res = await cartCount()
            if (res.status === 200) {
                this.setCartNum(res.data.count)
            } else {
                this.$message.warning(res.msg)
            }
        },
        select () { this.read = !this.read },
        register () {
            if (!this.read) {
                return this.$message.warning('Please read the GRAVITY SHOP Privacy Terms first')
            } else if (this.pwd1.length < 4 || this.pwd1.length > 16) {
                return this.$message.warning('Please enter a 4-16 character password')
            } else if (this.pwd1 !== this.pwdAgain) {
                return this.$message.warning('Passwords do not match')
            }
            this.loading1 = true
            registerID({
                account: this.phoneNumber1,
                captcha: this.authCode1,
                password: this.pwd1
            }).then(res => {
                if (res.status === 200) {
                    this.$message.success('Registration successful')
                    setTimeout(() => {
                        this.toLogin()
                    }, 1000)
                } else {
                    this.$message.warning(res.msg)
                }
            })
            this.loading1 = false
        },
        getBack () {
            this.loading = true
        },
        async getUserInfo () {
            var res = await getUserInfo()
            if (res.status === 200) {
                this.$store.commit('setLoginVisible', false)
                this.setUserInfo(res.data)
                this.$router.go(0)
            }
        },
        handleClose () { this.$store.commit('setLoginVisible', false) }
    }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables.scss";

.login {
  ::v-deep .premium-dialog {
    border-radius: $border-radius-lg;
    overflow: hidden;
    box-shadow: $shadow-lg !important;
    background: rgba($white, 0.95);
    backdrop-filter: blur(10px);
    border: 1px solid rgba($white, 0.2);

    .el-dialog__header {
      display: none; // We'll use our own header
    }

    .el-dialog__body {
      padding: 40px;
    }
  }
}

.dialog-content {
  text-align: center;
}

.dialog-title {
  font-size: 24px;
  font-weight: 700;
  color: $gray-900;
  margin-bottom: 8px;
}

.dialog-subtitle {
  font-size: 14px;
  color: $gray-500;
  margin-bottom: 24px;
}

.form-group {
  text-align: left;
  margin-bottom: 20px;

  .form-label {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: $gray-700;
    margin-bottom: 8px;
  }
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;

  .input-icon {
    position: absolute;
    left: 12px;
    color: $gray-400;
    font-size: 18px;
    pointer-events: none;
  }

  input {
    padding-left: 40px !important; // Room for icon
    height: 48px;
    background-color: $gray-50;
    border: 1px solid $gray-200;
    
    &:focus {
      background-color: $white;
      border-color: $primary-color;
    }
  }
}

.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.link-text {
  font-size: 14px;
  color: $primary-color;
  cursor: pointer;
  font-weight: 500;
  transition: $transition-fast;

  &:hover {
    color: $primary-hover;
    text-decoration: underline;
  }
}

.premium-btn {
  height: 50px;
  font-size: 16px;
  letter-spacing: 1px;
}

.clause-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.checkbox-custom {
  width: 18px;
  height: 18px;
  border: 2px solid $gray-300;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: $transition-fast;

  i {
    font-size: 12px;
    color: $white;
    display: none;
  }

  &.active {
    background-color: $primary-color;
    border-color: $primary-color;
    i {
      display: block;
    }
  }
  
  &:hover {
    border-color: $primary-color;
  }
}

.clause-text {
  font-size: 13px;
  color: $gray-600;
}

.text-center { text-align: center; }
.gray-500 { color: $gray-500; }
.fs14 { font-size: 14px; }
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue